module.exports = __webpack_public_path__ + "static/media/file.4ffe0eb8.svg";